import { GlobalOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetProfileByRoleApi } from '../../../hooks/Client/UseClient';
import useFacebookPixel from '../../../hooks/facebookPixelHook';
import { AppState } from '../../../redux/store';
import { useLanguage } from '../../../components/LanguageContext';

type Props = {}

const ToggleLang = (props: Props) => {
    const Language = useSelector((state: AppState) => state.language.type);
    const state = useSelector((state: AppState) => state)
    const role = state.client.Token ? 'client' : state.consultant.Token ? "consultant" : state.admin.Token ? "admin" : ""
    const pixelId = process.env.REACT_APP_PIXEL_ID;
    const trackPixelEvent = useFacebookPixel(pixelId);
    const [MyProfile] = useGetProfileByRoleApi(role, 'my-profile');
    const { currentLanguage, switchLanguage } = useLanguage();

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguage');
        if (!storedLanguage) {
            localStorage.setItem('selectedLanguage', Language || 'en');
        }
    }, [Language]);

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLanguage = e.target.value as 'en' | 'fr';
        localStorage.setItem('selectedLanguage', selectedLanguage);

        // Use the context method to switch language (updates both Redux and URL)
        switchLanguage(selectedLanguage);

        if (role) {
            trackPixelEvent("language_change", {
                selected_language: Language,
                role,
                anonymized_user_id: MyProfile?.[0]?._id,
                name: MyProfile?.[0]?.given_name,
            })
        }
    };

    return (
        <div className="d-flex items-center border rounded-full px-2 py-2 mx-2 bg-white">
            <GlobalOutlined className="mr-1" />
            <select
                className="border-0 focus:outline-none bg-transparent"
                onChange={handleLanguageChange}
                value={currentLanguage}
            >
                <option value="en">En</option>
                <option value="fr">Fr</option>
            </select>
        </div>
    );
}

export default ToggleLang;

